import { createFileRoute, Outlet } from '@tanstack/react-router';
import LayoutWrapper from 'src/layouts/PartnerPortal';
import PartnerPortalTabs from 'src/components/partner-portal/Tabs';

export const Route = createFileRoute('/partner_/$partnerId')({
	component: Authentication,
});

function Authentication() {
	const { partnerId } = Route.useParams();

	return (
		<LayoutWrapper>
			<PartnerPortalTabs partnerId={partnerId} />
			<Outlet />
		</LayoutWrapper>
	);
}
